<template>
  <div class="subscription-plan-card" :class="{ ['show-details']: showDetails }">
    <div class="plan-header" :class="planType(plan.id!)">
      {{ plan.displayName }}
    </div>
    <SubscriptionPrice :plan="plan" />
    <div v-if="showDetails" class="plan-details">
      <ul class="list-unstyled">
        <li>
          <img src="@/assets/icons/simple_tree.svg" alt="Tree"/>
          {{ plan.treeLimit }} trees
        </li>
        <li>
          <ImageIcon/>
          {{ getPlanContentLimitText(plan.contentLimit) }} photos
        </li>
        <li>
          <img src="@/assets/icons/group_gray_150.png" alt="People"/>
          {{ plan.shareLimit }} people
        </li>
      </ul>
      <router-link to="/plans">Full details</router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.subscription-plan-card {
  --plan-border-color: #ddd;
  --plan-border-radius: 6px;

  max-width: 180px;
  border-radius: var(--plan-border-radius);
  border: 1px var(--plan-border-color) solid;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  display: grid;
  grid-template-columns: 1fr;

  &.show-details {
    max-width: 500px;
    grid-template-columns: 150px 1fr;

    .plan-header {
      grid-column: 1 / span 2;
    }
  }

  .plan-header {
    width: 100%;
    height: 2.2rem;
    border-bottom: 1px solid var(--plan-border-color);
    // border-top-left-radius: var(--plan-border-radius);
    // border-top-right-radius: var(--plan-border-radius);
    background-color: var(--page-bg-alt3);
    font-size: 1.3rem;
    text-align: center;
  }

  .plan-details {
    display: flex;
    flex-direction: column;
    padding: 0.5rem;
    font-size: 0.875rem;

    ul {
      margin: 0;

      li svg, li img {
        width: 16px;
        margin-right: 0.25rem;
        filter: brightness(0) invert(1) brightness(0.7);
      }
    }
    
    a {
      margin-top: auto;
    }
  }
}
</style>

<script lang="ts" setup>
import { getPlanContentLimitText, SubscriptionPlan } from '@/gp/GroupAdminModel'
import SubscriptionPrice from './SubscriptionPrice.vue'
import { CheckIcon, ImageIcon } from '@zhuowenli/vue-feather-icons';

const props = defineProps<{
  plan: SubscriptionPlan
  showDetails?: boolean
}>()

function planType(planId: string) {
  return planId.split('.')[0] // "mem.1" => "mem"
}
</script>
